const inViewport = (selector, callback, options, ...args) => {
    const El = Array.from(document.querySelectorAll(selector));

    if (El) {
        if ('IntersectionObserver' in window) {
            let defaultOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            };

            let observer = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            callback(entry.target, args);
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { defaultOptions, ...options }
            );

            El.forEach(app => {
                observer.observe(app);
            });
        } else {
            callback(El[0], args);
        }
    }
};

export default inViewport;
